import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import { SplashScreen } from "@capacitor/splash-screen";
SplashScreen.hide();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);


if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker.js")
   
  });
}

window.addEventListener("storage", (e) => {
  if (e.key === "logout") {
     window.location.replace("/login");
  }
});